<template>
  <div>
    <div>
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs headline="Quản lý nạp xu" :link="[]" />
        </div>
        <div>
          <v-btn class="mx-1 mt-2" dark color="#0D47A1" @click="openDialog">
            <v-icon left>mdi-transfer-up</v-icon>
            Nạp trực tiếp
          </v-btn>
        </div>
      </div>
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <AddCoinFilter />
      </v-card>
      <v-card outlined class="mx-4 elevation-0">
        <AddCoinTable />
      </v-card>
    </div>
    <DialogAddCoin ref="dialog-add-coin" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import AddCoinTable from '../../modules/add-coin-manager/AddCoinTable.vue'
import AddCoinFilter from '../../modules/add-coin-manager/AddCoinFilter.vue'
import DialogAddCoin from '../../modules/add-coin-manager/DialogAddCoin.vue'
export default {
  components: { Breadcrumbs, AddCoinTable, AddCoinFilter, DialogAddCoin },
  methods: {
    openDialog() {
      this.$refs['dialog-add-coin'].openDialog()
    },
  },
}
</script>

<style lang="scss" scoped></style>
